import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnCashStack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M5.808 8.835v3.463m9.549-3.463v3.463m2.99-4.751C20.098 7.782 21 8.893 21 11.01v4.849c0 2.424-1.47 3.463-3.673 3.463H9.51c-2.035 0-3.47-.67-3.673-2.716m8.655-.152H6.673C4.469 16.454 3 15.415 3 12.991V8.142C3 5.718 4.47 4.68 6.673 4.68h7.818c2.204 0 3.673 1.039 3.673 3.463v4.849c0 2.424-1.47 3.463-3.673 3.463m-1.706-5.888c0 1.148-.987 2.078-2.204 2.078s-2.203-.93-2.203-2.078.986-2.078 2.203-2.078 2.204.93 2.204 2.078"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnCashStack;
